// QuestionCard.jsx
import React from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import QuestionInput from './QuestionInput';
import Navigation from './Navigation';

const QuestionCard = ({
  question,
  tempValue,
  error,
  saving,
  organization,
  isViewer,
  onResponseChange,
  currentIndex,
  totalQuestions,
  onPrevious,
  onNext,
  onReview,
  canProgress,
  showReviewButton,
}) => {
  // Guard against missing question
  if (!question) {
    console.warn('QuestionCard: No question data provided');
    return null;
  }

  return (
    <Card className="mb-4">
      <CardHeader>
        <h3 className="text-lg font-medium text-gray-900">
          {question.question_text}
          {question.required && <span className="text-red-500 ml-1">*</span>}
        </h3>
      </CardHeader>

      <CardContent className="space-y-6">
        {/* Question Input */}
        <div className="space-y-4">
          <QuestionInput
            question={question}
            value={tempValue}
            onChange={onResponseChange}
            disabled={isViewer}
            saving={saving}
            organization={organization}
          />
          {error && (
            <p className="text-sm text-red-600">{error}</p>
          )}
        </div>

        {/* Navigation */}
        <Navigation
          currentIndex={currentIndex}
          totalQuestions={totalQuestions}
          onPrevious={onPrevious}
          onNext={onNext}
          onReview={onReview}
          saving={saving}
          canProgress={canProgress}
          showReviewButton={showReviewButton}
        />
      </CardContent>
    </Card>
  );
};

export default QuestionCard;